import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { api } from "../App";
import { rememberPromotion } from "../lib/referrals";

export default function ReferralLandingPage() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    const key = `aorra:visit:${code}`;
    let visitId = sessionStorage.getItem(key);
    if (!visitId) {
      visitId = window.crypto.randomUUID();
      sessionStorage.setItem(key, visitId);
    }
    api.post(`/promotions/links/${encodeURIComponent(code)}`, { visit_id: visitId }).then(({ data: result }) => {
      if (!active) return;
      rememberPromotion(result.code);
      setData(result);
      if (result.kind === "personal" && result.whatsapp_url) window.location.assign(result.whatsapp_url);
    }).catch(err => { if (active) setError(err.response?.data?.detail || "No pudimos abrir esta invitación."); });
    return () => { active = false; };
  }, [code]);
  return <main className="flex min-h-screen items-center justify-center bg-[#F4F7FF] p-6 font-['Manrope']"><div className="w-full max-w-sm rounded-3xl border border-blue-100 bg-white p-8 text-center shadow-lg">
    <img src="/logo-principal.png" alt="Aorra" className="mx-auto mb-6 h-10 object-contain" />
    {!data && !error && <Loader2 className="mx-auto animate-spin text-blue-600" />}
    {error ? <><h1 className="text-xl font-extrabold text-[#1B2559]">Invitación no disponible</h1><p className="mt-3 text-sm text-slate-600">{error}</p></> : data && <>
      <h1 className="text-2xl font-extrabold text-[#1B2559]">Tu invitación a Aorra</h1>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">Comienza a organizar tus finanzas.{data.discount_type === "fixed" ? " Tu código ofrece un descuento fijo según el plan que elijas." : data.percent > 0 ? ` Tu código ofrece ${data.percent} % de descuento en planes elegibles.` : ""}</p>
      <p className="mt-4 rounded-xl bg-blue-50 py-3 font-bold tracking-wider text-blue-700">{data.code}</p>
      {data.whatsapp_url && <a href={data.whatsapp_url} className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-[#396BE9] px-4 py-3 text-sm font-bold text-white">Continuar por WhatsApp <ArrowRight size={16} /></a>}
      {data.kind === "personal" && <p className="mt-2 text-xs text-slate-500">Envía el mensaje con el código para registrar tu invitación.</p>}
    </>}
    <Link to="/login" className="mt-5 block text-sm font-semibold text-[#396BE9]">Continuar en el portal</Link>
  </div></main>;
}
